import { render, staticRenderFns } from "./ModalAppointment.vue?vue&type=template&id=16e20c08&"
import script from "./ModalAppointment.vue?vue&type=script&lang=js&"
export * from "./ModalAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports